import { render, staticRenderFns } from "./ConstructionWorkerEditDetailsTab.vue?vue&type=template&id=5349b5b8"
import script from "./ConstructionWorkerEditDetailsTab.vue?vue&type=script&lang=ts"
export * from "./ConstructionWorkerEditDetailsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports